import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'


const responseParser = (response: any) => {
    return isSuccessResponse(response)
}



const generateFinHubReport = (payload: any, tokens: any) => {
    const config = sitConfig(tokens);
    // config.headers['x-user-id'] = 'harshit.agrawal@ril.com'
    //  config.headers['x-channel-id'] = '322287787654'
    const request: JFSRequest<{}> = {
        apiPath: getUrl(APIEndPoints.generateSalesRecord),
        method: 'POST',
        config: config,
        headers: getHeaders(),
        body: payload,
    }

    return executeRequest(request)
        .then(responseParser)
        .catch((error) => {
            throw error
        })
}

export const downloadFinhubReportApi = (fileName: any, tokens: any) => {
    const config = sitConfig(tokens);
    // config.headers['x-user-id'] = 'harshit.agrawal@ril.com'
    // config.headers['x-channel-id'] = '322287787654'
    const request: JFSRequest<{}> = {
        apiPath: getUrl(APIEndPoints.downloadFinHubRecords),
        method: 'POST',
        responseType: 'arraybuffer',
        config,
        headers: getHeaders(),
        body: { fileName },
    }

    return executeRequest(request)
        .then((response) => {
            if (isSuccessResponse(response)) {
                return response;
            }
        })
        .catch((error) => {
            throw error
        })

}

const getGenerateFinHubReportReq = (month: string, year: string) => ({
    month,
    year,

})
export { generateFinHubReport, getGenerateFinHubReportReq }

